export const CALENDLY_URL = "https://calendly.com/summercrestai";

export const FAQS = [
    {
        icon: "database",
        q: "IS THIS JUST FOR COMPLETELY DORMANT CLIENTS?",
        a: "No. The system can also identify clients who are becoming overdue based on the clinic’s agreed rebooking rules, as well as people who cancelled or never booked their next appointment.",
    },
    {
        icon: "calendar",
        q: "DO WE HAVE TO CHANGE OUR BOOKING SOFTWARE?",
        a: "The goal is to work around the systems you already use wherever technically possible. We review your current setup before anything is built.",
    },
    {
        icon: "message",
        q: "ARE YOU MESSAGING OUR ENTIRE DATABASE?",
        a: "No. The database is segmented first so the right clients receive the right outreach. Clients who should not be contacted are excluded.",
    },
    {
        icon: "check",
        q: "WILL THE MESSAGES SOUND ROBOTIC?",
        a: "No. Messaging is approved around your clinic, services and tone before campaigns go live.",
    },
    {
        icon: "refresh",
        q: "IS THIS A ONE-OFF CAMPAIGN?",
        a: "It can start with an existing database reactivation campaign, but the bigger opportunity is an ongoing system that continually identifies clients who become overdue and follows them up.",
    },
    {
        icon: "analytics",
        q: "HOW WILL WE KNOW IF IT WORKED?",
        a: "We track the outcome that matters: rebookings generated through the system. Depending on the clinic setup, reporting can also include responses, appointments and attributable revenue.",
    },
    {
        icon: "shield",
        q: "WHAT ABOUT PRIVACY AND CONSENT?",
        a: "Outreach is built around the clinic’s communication permissions and the applicable privacy, consent and opt-out requirements. The rules are established during onboarding before any messages are sent.",
    },
];

export const TESTIMONIALS = [
    {
        quote: "We used to miss calls and forget follow-ups constantly. Now everything is automated and seamless. Summercrest AI is the best investment we have made this year.",
        name: "James Carter",
        role: "Laser Clinic Owner",
    },
    {
        quote: "Their team understood our needs from day one. The AI systems they built have saved us countless hours and our content output has tripled.",
        name: "Trần Ngọc Anh",
        role: "Injectable Aesthetic Clinic Owner",
    },
    {
        quote: "We used to miss calls and forget follow-ups constantly. Now everything is automated and seamless. Summercrest AI is the best investment we have made this year.",
        name: "Daniel Park",
        role: "Dentist & Practice Owner",
    },
];
